import React, {useEffect, useState} from 'react';
import {Drawer, Menu, Collapse, Row, Col, Space} from 'antd';
import './ToggleSwitch.css';
import {useNavigate, useSearchParams} from 'react-router-dom';
import closeIcon from './../../../Assets/close.svg';
import {UserOutlined} from '@ant-design/icons';
import {createSelectionMenuOptionsUtil} from '../../../Util/commonUtility';
import {useDispatch, useSelector} from 'react-redux';
import {setMenuRoute} from '../../../Store/Actions';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';
const {Panel} = Collapse;

const ToggleSwitch = ({profileView, logout, chapterList, chapterLogo}) => {
  const {ApplicationString, currentLanguage, changeLanguage} =
    useLocalization();
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const {setMenuRouteState} = useSelector(({chapters}) => chapters);
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const currentPath = window.location.pathname;

  const visibleChapters = chapterList?.filter((chapter) => {
    return chapter?.is_visible_on_map === true;
  });

  const handleLanguageChange = () => {
    if (currentLanguage === LANGUAGES.JA) {
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };

  const handleNavbarLinkClick = (path) => {
    navigate(path);
    if (currentLanguage === LANGUAGES.JA) {
      changeLanguage(LANGUAGES.EN);
      localStorage.setItem('pbssLanguage', LANGUAGES.EN);
      searchParams.delete('language');
    }
  };

  const userLogout = () => {
    logout();
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
    if (!isChecked) {
      setIsDrawerVisible(true);
    }
  };

  const navigate = useNavigate();
  const onMenuItemClick = (e) => {
    setIsChecked(false);
    handleCloseDrawer();
    handleNavbarLinkClick(`/${e.key}`);
    if (e.onClick) {
      e.onClick();
    }
  };

  useEffect(() => {
    handleCloseDrawer();
  }, [setMenuRouteState]);

  const menus = [
    {
      id: 'header-aboutpbss-1',
      label: ApplicationString['mainLayoutComponent.navbar.aboutPbss'],
      key: 'aboutUs',
    },
    {
      id: 'header-events-2',
      label: ApplicationString['mainLayoutComponent.navbar.events'],
      key: 'events',
      children: [
        {
          label: ApplicationString['mainLayoutComponent.navbar.pickALocation'],
          key: 'PickLocation',
          children: [
            ...createSelectionMenuOptionsUtil(
              visibleChapters,
              'normalized_name',
              'name',
            ),
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.pbssInternational'
                ],
              key: '',
            },
          ],
          onClick: () => {
            handleLanguageChange();
          },
        },
        {
          label: ApplicationString['mainLayoutComponent.navbar.eventTypesInfo'],
          key: 'EventTypes',
          children: [
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.seminarLuncheons'
                ],
              key: 'eventType/seminarLuncheons',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.workshops'
                ],
              key: 'eventType/workshops',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.symposia'
                ],
              key: 'eventType/symposia',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.webinars'
                ],
              key: 'eventType/webinars',
            },
            {
              label:
                ApplicationString[
                  'mainLayoutComponent.navbar.eventTypesInfo.dinnerSeminars'
                ],
              key: 'eventType/dinnerSeminars',
            },
          ],
        },
      ],
    },
    {
      id: 'header-sponsorships-2',
      label: ApplicationString['mainLayoutComponent.navbar.sponsorships'],
      key: 'sponsorshipInfo',
    },
    {
      id: 'header-jobs-4',
      label: ApplicationString['mainLayoutComponent.navbar.jobPostings'],
      key: 'jobs/approved',
    },
    {
      id: 'header-resources-5',
      label: ApplicationString['mainLayoutComponent.navbar.resources'],
      key: 'resources',
      children: [
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.stemOutreach'
            ],
          key: 'stemOutreach',
        },
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.industryOutreach'
            ],
          key: 'industryOutreach',
        },
        {
          label:
            ApplicationString[
              'mainLayoutComponent.navbar.resources.careerMentorship'
            ],
          key: 'careerMentorship',
        },
        {
          label:
            ApplicationString['mainLayoutComponent.navbar.resources.partners'],
          key: 'Partners',
        },
      ],
    },
    {
      id: 'header-contactus-6',
      label: ApplicationString['mainLayoutComponent.navbar.contactUs'],
      key: 'contactUs',
    },
    {
      id: 'header-faq-7',
      label: ApplicationString['mainLayoutComponent.navbar.faq'],
      key: 'faq',
    },
  ];

  const handleCloseDrawer = () => {
    setIsDrawerVisible(false);
    setIsChecked(false);
    dispatch(setMenuRoute(false));
  };

  return (
    <div className='toggle-switch'>
      <input
        id='checkbox'
        type='checkbox'
        checked={isChecked}
        onChange={handleToggle}
      />
      <label
        className={`toggle ${isChecked ? 'checked' : ''}`}
        htmlFor='checkbox'>
        <div id='bar1' className='bars'></div>
        <div id='bar2' className='bars'></div>
        <div id='bar3' className='bars'></div>
      </label>

      <Drawer
        className='mobile-menu'
        placement='right'
        closable={true}
        closeIcon={<img src={closeIcon} />}
        onClose={handleCloseDrawer}
        visible={isDrawerVisible}
        width={'fit-content'}
        extra={
          <Space>
            <img
              onClick={() => {
                handleCloseDrawer();
                handleNavbarLinkClick('/');
              }}
              className='drawer-header-logo'
              crossOrigin='anonymous'
              src={chapterLogo}
            />
          </Space>
        }>
        <Menu
          onClick={onMenuItemClick}
          className='drawer-menu'
          prefixCls={`pbss-menu`}
          mode='inline'
          items={menus}
        />

        <Row gutter={[48]} className='profile-auth-container'>
          {userInfo && userInfo.role ? (
            <Col span={24}>
              <Collapse
                prefixCls='account-collapse'
                expandIconPosition='end'
                accordion>
                <Panel
                  header={
                    <span>
                      <UserOutlined />
                      {
                        ApplicationString[
                          'profileViewComponent.button.myAccount'
                        ]
                      }
                    </span>
                  }
                  key='1'>
                  {profileView}
                </Panel>
              </Collapse>
            </Col>
          ) : null}
          <Col span={24}>
            <div className='auth-button-container'>
              {userInfo && userInfo.role ? (
                <button
                  className='common-button-header bg-remove extend-button-w extend-settings-button'
                  onClick={userLogout}>
                  {ApplicationString['mainLayoutComponent.navbar.logout']}
                </button>
              ) : (
                <>
                  {currentPath !== '/register' && (
                    <button
                      onClick={() => {
                        handleCloseDrawer();
                        handleNavbarLinkClick('/register');
                      }}
                      id='join'
                      className='common-button-header bg-remove extend-button-w extend-settings-button'>
                      {ApplicationString['mainLayoutComponent.navbar.join']}
                    </button>
                  )}
                  {currentPath !== '/login' && (
                    <button
                      onClick={() => {
                        handleCloseDrawer();
                        handleNavbarLinkClick('/login');
                      }}
                      id='login'
                      className='common-button-header extend-settings-button'>
                      {ApplicationString['mainLayoutComponent.navbar.login']}
                    </button>
                  )}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Drawer>
    </div>
  );
};

export default ToggleSwitch;
